import { AutogenModelEdistandardcodeList, AutogenRowEdistandardcodeList } from "./autogen/AutogenModelEdistandardcodeList";

export class ModelEdistandardcodeList extends AutogenModelEdistandardcodeList<RowEdistandardcodeList> {
	constructor() {
		super(RowEdistandardcodeList);
	}
}

export class RowEdistandardcodeList extends AutogenRowEdistandardcodeList {
}